@charset "UTF-8";
/*!The new CSS reset - version 1.7.3 (last updated 7.8.2022)
GitHub page: https://github.com/elad2412/the-new-css-reset
***/
*:where(:not(html, iframe, canvas, img, svg, video, audio):not(svg *, symbol *)) {
  all: unset;
  display: revert;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

a, button {
  cursor: revert;
}

ol, ul, menu {
  list-style: none;
}

table {
  border-collapse: collapse;
}

input, textarea {
  -webkit-user-select: auto;
}

textarea {
  white-space: revert;
}

meter {
  -webkit-appearance: revert;
  -moz-appearance: revert;
  appearance: revert;
}

::-moz-placeholder {
  color: unset;
}

::placeholder {
  color: unset;
}

:where([hidden]) {
  display: none;
}

:where([contenteditable]:not([contenteditable=false])) {
  -moz-user-modify: read-write;
  -webkit-user-modify: read-write;
  overflow-wrap: break-word;
  -webkit-line-break: after-white-space;
  -webkit-user-select: auto;
}

:where([draggable=true]) {
  -webkit-user-drag: element;
}

body {
  margin: 0;
}

/******************************
共通設定
******************************/
:root {
  --header-height: 7.5rem;
  --wrapper-width: 120rem;
  --overall-padding: 4rem;
  --gradient-30under30: linear-gradient(to right, #D0FD4A 0%, #FFD45E 33.33%, #FF7F9D 66.66%, #6657F6 100%);
}

html {
  font-size: 62.5%;
}

body {
  background: #1E1E1E;
  color: #fff;
  font-size: 1.8rem;
  line-height: 2;
  letter-spacing: 0.04em;
  font-family: "source-han-sans-jp-variable", sans-serif;
  font-variation-settings: "wght" 700;
  word-break: break-all;
}
body.is-menuOpen, body.is-noscroll {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
}

img {
  vertical-align: bottom;
}

*:focus:not(:fous-visible) {
  outline: none;
}

*:focus-visible {
  outline: 3px solid #1a73e8;
  outline-offset: 4px;
}

.textjus {
  text-align: justify;
  text-justify: inter-ideograph;
}

.csshover {
  transition: opacity 0.6s;
}

.tb-show {
  display: none;
}

.tb-hide {
  display: block;
}

.tb-only-show {
  display: none;
}

.tb-only-hide {
  display: block;
}

.sp-show {
  display: none;
}

.sp-hide {
  display: block;
}

.sp-show-inline {
  display: none;
}

.sp-hide-inline {
  display: inline;
}
.wrapper {
  width: min(100%, var(--wrapper-width) + var(--overall-padding) * 2);
  margin: 0 auto;
  padding: 0 var(--overall-padding);
}

.no-br-item {
  display: inline-block;
}

[data-aos=custom_fade] {
  opacity: 0;
  transition: opacity 1s;
}
[data-aos=custom_fade].aos-animate {
  opacity: 1;
}

[data-aos=custom_fadeup] {
  translate: 0 2rem;
  opacity: 0;
  transition: opacity 0.8s, translate 0.8s;
}
[data-aos=custom_fadeup].aos-animate {
  translate: 0 0;
  opacity: 1;
}

.common_link_hover_slide_bg {
  background: linear-gradient(to right, #fff 0, #fff 50%, #111 50%, #111 100%) 200% 0/200% 100%;
  transition: background-position 0.4s;
}
.common_link_hover_slide_bg[data-bg-color=black_to_white] {
  background-image: linear-gradient(to right, #111 0, #111 50%, #fff 50%, #fff 100%);
}

.common_link_hover_slide_bg_color-change {
  mix-blend-mode: difference;
}

.common_link_arrow {
  width: 2.2rem;
  height: 0.7rem;
}

.common_modal {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s, visibility 0s ease 0.4s;
}
.common_modal[aria-hidden=false] {
  opacity: 1;
  transition-delay: 0s;
  visibility: visible;
}

.common_modal_inner {
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  width: 100%;
  max-width: 63rem;
  max-height: 90%;
  padding: 5rem 5rem 4rem;
  background: #fff;
  color: #111;
  overflow-y: auto;
  overflow-x: hidden;
  overflow-scrolling: touch;
  overscroll-behavior-y: contain;
}

.common_modal_close_wrap {
  position: sticky;
  z-index: 10;
  top: 0;
  height: 0;
}

.common_modal_close {
  position: absolute;
  top: -3.1rem;
  right: -4.8rem;
  width: 4rem;
  height: 4rem;
  cursor: pointer;
}
.common_modal_close::before, .common_modal_close::after {
  position: absolute;
  top: 50%;
  left: calc(50% - 2.75rem);
  display: block;
  content: "";
  width: 3rem;
  height: 1px;
  background: #111;
  transform-origin: center center;
  rotate: 45deg;
  speak: none;
}
.common_modal_close::after {
  rotate: -45deg;
}

.common_modal_slider_name_ja {
  font-size: 3rem;
  line-height: 1.3;
}

.common_modal_slider_position {
  margin: 1rem 0 0;
  font-size: 1.6rem;
  line-height: 1.3;
}

.common_modal_slider_outline {
  margin: 1.5rem 0 0;
  font-size: 1.8rem;
  line-height: 1.3;
}

.common_modal_slider_prev,
.common_modal_slider_next {
  top: 4.3rem;
  left: auto;
  right: 6.6rem;
  width: 4rem;
  height: 4rem;
}
.common_modal_slider_prev::after,
.common_modal_slider_next::after {
  display: none;
}

.common_modal_slider_prev {
  right: 11.3rem;
  transform: scale(-1, 1);
}

.common_modal .common_modal_slider_arrow {
  width: 3.1rem;
  height: 1rem;
}

.common_modal_bg_pic {
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.common_modal_bg_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.sns_list {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3.6rem;
}

.sns_list_link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sns_list_svg {
  width: 3rem;
  height: 3rem;
  transition: scale 0.4s;
}

.sns_list_svg_youtube {
  width: 3.5rem;
  height: 2.5rem;
}

.sns_list_instagram_pic {
  display: block;
  width: 3rem;
  height: 3rem;
}

.sns_list_instagram_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  vertical-align: top;
  transition: scale 0.6s;
}
.sns_list_use_x {
  fill: #000;
}
#footer .sns_list_use_x {
  fill: #fff;
}

/******************************
ヘッダー
******************************/
#header {
  z-index: 99;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2.3rem 0 3rem;
  background: #fff;
  color: #111;
  height: var(--header-height);
  width: 100%;
}

.head_logo_forbes {
  z-index: 10;
  position: relative;
  width: 10.5rem;
  height: 2.6rem;
}

.head_logo_forbes_use {
  fill: #000;
}

#menu_trigger {
  display: none;
}

.menu_trigger_item {
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  width: 2.4rem;
  height: 1px;
  background: rgb(17, 17, 17);
  transition: background-color 0.4s;
}
.menu_trigger_item::before, .menu_trigger_item::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  translate: 0 -0.9rem;
  background: #111;
  transition: translate 0.4s, rotate 0.4s;
  speak: none;
}
.menu_trigger_item::after {
  translate: 0 0.9rem;
}
#menu_trigger[aria-expanded=true] .menu_trigger_item {
  background-color: rgba(17, 17, 17, 0);
}
#menu_trigger[aria-expanded=true] .menu_trigger_item::before, #menu_trigger[aria-expanded=true] .menu_trigger_item::after {
  translate: 0 0;
  rotate: 225deg;
}
#menu_trigger[aria-expanded=true] .menu_trigger_item::after {
  rotate: -225deg;
}

#menu {
  display: flex;
  align-items: center;
  gap: 0 3.8rem;
  font-size: 3rem;
}

#menu_list {
  display: flex;
  align-items: center;
  gap: 0 1.1rem;
  gap: 0 1.9rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  font-weight: 700;
}

.menu_item {
  padding: 0 0.2rem 0 0.1rem;
  background-image: linear-gradient(to right, #fff 0, #fff 50%, #111 50%, #111 calc(100% - 0.2rem), transparent calc(100% - 0.2rem), transparent 100%);
  background-repeat: no-repeat;
}

.menu_link {
  mix-blend-mode: difference;
  color: #fff;
}

.header_x {
  border-radius: 0.6rem;
  border: solid 1px #111;
}

.header_x_inner {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 0.3rem 3.5rem 0.3rem 2.9rem;
  color: #fff;
  font-size: 1.6rem;
  letter-spacing: normal;
}

.header_x_arrow_use {
  fill: #fff;
}

.header_sns_list {
  display: none;
}

/******************************
メイン
******************************/
main {
  overflow-x: clip;
}

/******************************
ADVISORY BOARD 共通
******************************/
.advisoryboard_lead {
  display: flex;
  margin: 0 calc(50% - 50vw);
}

.advisoryboard_lead_pic {
  display: block;
  width: 29.6rem;
}

.advisoryboard_lead_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: top right;
  object-position: top right;
}

.advisoryboard_lead_bottom_img {
  -o-object-position: top left;
  object-position: top left;
}

.advisoryboard_lead_content {
  flex: 1;
  min-width: 65.1rem;
  padding: 6.8rem 3.4rem 6rem;
  text-align: center;
  background: #fff;
  color: #111;
}

.advisoryboard_lead_title {
  font-size: 10rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.advisoryboard_lead_body {
  margin: 2.8rem 0 0;
  line-height: 2;
}

.advisoryboard_lead_link {
  display: block;
  max-width: 40rem;
  margin: 3.8rem auto 0;
  border: solid 2px #111;
  border-radius: 0.6rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  letter-spacing: normal;
}

.advisoryboard_lead_link_inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem 0;
  color: #fff;
  font-size: 3rem;
  line-height: 0.85;
}

.advisoryboard_lead_link_arrow {
  fill: #fff;
}

/******************************
フッター
******************************/
#footer {
  padding: 5.2rem 0;
  background: #000;
  color: #727272;
  text-align: center;
}

.footer_logo_forbes {
  margin: 4.5rem 0 0;
  width: 13.5rem;
  height: 3.4rem;
}

.footer_logo_forbes_use {
  fill: #fff;
}

.footer_copy {
  margin: 1.9rem 0 0;
  color: #666;
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.05em;
  line-height: 1;
}

/******************************
wwebフォント表示設定
******************************/
#header,
main,
#footer {
  opacity: 0;
}

.wf-active #header,
.wf-inactive #header {
  opacity: 1;
}
.wf-active main,
.wf-active #footer,
.wf-inactive main,
.wf-inactive #footer {
  opacity: 1;
}

/******************************
メイン
******************************/
#top_main {
  position: relative;
  display: grid;
  height: 73.5rem;
  overflow: hidden;
}

.top_main_text {
  z-index: 1;
  position: relative;
  justify-self: center;
  align-self: flex-end;
  grid-column-start: 1;
  grid-row-start: 1;
  padding: 0 0 9.1rem;
  text-align: center;
}

.top_main_logo30u30 {
  width: 14.3rem;
  height: 9.8rem;
}

.top_main_catch {
  margin: -0.5rem 0 0;
  font-size: 2.6rem;
}

.top_main_title {
  margin: 0.6rem 0 0;
  font-size: 15rem;
  line-height: 0.833;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.top_main_images {
  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  height: 73.5rem;
  position: absolute;
  left: 50%;
  translate: -50% 0;
}

.top_main_images_item {
  flex-shrink: 0;
  display: flex;
}
.wf-active .top_main_images_item, .wf-inactive .top_main_images_item {
  animation: top_main_images_animation 40s infinite linear 0s both;
}

@keyframes top_main_images_animation {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
.top_main_pic {
  position: relative;
  display: block;
  width: 36rem;
  aspect-ratio: 360/735;
}

.top_main_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

/******************************
2025 HONOREES
******************************/
#top_honorees {
  padding: 7.8rem 0 0;
}

[data-color=honorees-entertainment] {
  --honorees-category-color: #7224D8;
}

[data-color=honorees-art] {
  --honorees-category-color: #FF7F9D;
}

[data-color=honorees-business] {
  --honorees-category-color: #F0C03B;
}

[data-color=honorees-science] {
  --honorees-category-color: #B1E21E;
}

[data-color=honorees-feature] {
  --honorees-category-color: #fff;
}

.top_honorees_title {
  text-align: center;
  font-size: 10rem;
  line-height: 1;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.top_honorees_title_hash {
  width: -moz-fit-content;
  width: fit-content;
  margin: 0.5rem auto 0;
  text-align: center;
  background: var(--gradient-30under30);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 4rem;
  line-height: 1;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.top_honorees_lead {
  margin: 3.2rem 0 0;
  text-align: center;
}

.top_honorees_anchor_list {
  z-index: 10;
  position: sticky;
  top: var(--header-height);
  display: flex;
  margin: 8.4rem 0 0;
  text-align: center;
}

.top_honorees_anchor_item {
  position: relative;
  flex-shrink: 0;
  width: 25%;
  color: var(--honorees-category-color);
  background-image: linear-gradient(to right, #111 0%, #111 50%, var(--honorees-category-color) 50%, var(--honorees-category-color) 100%);
  border: solid 1px var(--honorees-category-color);
  font-size: 4rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}
.top_honorees_anchor_item[data-color=honorees-art] {
  font-size: 5rem;
}

.top_honorees_anchor_link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 1.5rem 0;
  background-image: linear-gradient(to right, var(--honorees-category-color) 0%, var(--honorees-category-color) 50%, #fff 50%, #fff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.top_honorees_anchor_item.is-active {
  background-position: 100% 0;
}
.top_honorees_anchor_item.is-active .top_honorees_anchor_link {
  background-position: 100% 0;
}

.top_honorees_item {
  scroll-margin: calc(var(--header-height) + 10rem);
  margin: 4.8rem 0 0;
}

.top_honorees_item_title {
  padding: 0.5rem 1.4rem;
  border: solid 4px var(--honorees-category-color);
  border-width: 4px 0;
  color: var(--honorees-category-color);
  font-size: 8rem;
  line-height: 0.8;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.top_honorees_list_wrap {
  position: relative;
  overflow: hidden;
  background: #2F2F2F;
  padding: 6.2rem 7.75% 5rem 23.9rem;
}
.top_honorees_item:nth-child(2n) .top_honorees_list_wrap {
  padding: 6.2rem 23.9rem 4rem 7.75%;
}
.top_honorees_list {
  z-index: 1;
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 27.76%);
  gap: 4.2rem 8.36%;
}

.top_honorees_list_item {
  width: 100%;
}

.top_honorees_list_button {
  display: grid;
  grid-template-rows: repeat(3, auto) 1fr;
  width: 100%;
  cursor: pointer;
}

.top_honorees_list_pic {
  grid-area: 1/1/2/2;
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
}
.top_honorees_list_pic::after {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  content: "PROFILE";
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #D0FD4A 0%, #FFD45E 33.33%, #FF7F9D 66.66%, #6657F6 100%);
  opacity: 0.7;
  color: #000;
  font-size: 4rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  clip-path: polygon(0 0, 0 0, 0 100%, 0% 100%);
  transition: clip-path 0.4s;
  speak: none;
}

.top_honorees_list_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.top_honorees_list_name_en {
  z-index: 2;
  position: relative;
  grid-area: 1/1/2/2;
  align-self: flex-end;
  display: block;
  translate: 0 1.7rem;
  text-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.9);
  font-size: 4rem;
  line-height: 0.8;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}
.top_honorees_list_name_en .text_adjust1 {
  letter-spacing: -0.3em;
}

.top_honorees_list_name_ja {
  display: block;
  margin: 3.2rem 0 0;
  font-size: 2rem;
  line-height: 1.3;
}

.top_honorees_list_position {
  display: block;
  margin: 0.9rem 0 0;
  font-size: 1.4rem;
  line-height: 1.7142857143;
}

.top_honorees_list_icons {
  display: flex;
  align-items: center;
  gap: 1.4rem;
  margin: 1.4rem 0.3rem 0;
}

.top_honorees_list_profile {
  cursor: pointer;
  align-self: flex-start;
}

.top_honorees_list_ico {
  width: 4.2rem;
  height: 4.2rem;
  transition: scale 0.4s;
}

.top_honorees_list_ico_bg {
  fill: #fff;
  transition: fill 0.4s;
}

.top_honorees_list_ico_object {
  fill: var(--honorees-category-color);
  transition: fill 0.4s;
}
#feature .top_honorees_list_ico_object {
  fill: #000;
}
.top_honorees_list_item:first-child {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr repeat(2, auto) 1fr;
  gap: 0 9.21%;
  margin: 0 0 2.7rem;
}
.top_honorees_list_item:first-child .top_honorees_list_button {
  display: block;
  grid-row: span 4/span 4;
  width: 35rem;
}
.top_honorees_list_item:first-child .top_honorees_list_text_button {
  grid-column-start: 2;
  grid-row-start: 2;
  cursor: pointer;
}
.top_honorees_list_item:first-child .top_honorees_list_name_en {
  translate: 0 0;
  margin: 1.4rem 0 0;
  font-size: 7rem;
}
.top_honorees_list_item:first-child .top_honorees_list_name_ja {
  margin: 1.6rem 0 0;
}
.top_honorees_list_item:first-child .top_honorees_list_position {
  margin: 1rem 0 0;
  padding: 0;
  font-size: 1.6rem;
  line-height: 1.625;
}
.top_honorees_list_item:first-child .top_honorees_list_icons {
  grid-column-start: 2;
  grid-row-start: 3;
  gap: 2rem;
  margin: 2.4rem 0 0;
}
.top_honorees_list_item:first-child .top_honorees_list_ico {
  width: 6rem;
  height: 6rem;
}

.top_honorees_scroll_text {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  gap: 1rem;
  transform-origin: bottom left;
  rotate: 90deg;
  translate: 0 -100%;
}
.top_honorees_item:nth-child(2n) .top_honorees_scroll_text {
  left: 100%;
  transform-origin: top left;
  translate: 0 0;
}

.top_honorees_scroll_text_item {
  flex-shrink: 0;
  font-size: 22rem;
  line-height: 0.7454545455;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.06em;
  -webkit-text-stroke: 1px #666;
  text-stroke: 1px #666;
  paint-order: stroke;
  color: transparent;
  animation: honorees_scroll_text_animation 70s infinite linear 1s both;
}
#art .top_honorees_scroll_text_item {
  animation-duration: 66s;
}
#science .top_honorees_scroll_text_item {
  animation-duration: 62s;
}

@keyframes honorees_scroll_text_animation {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
/******************************
SPECIAL HONOREES
******************************/
[data-color=honorees-special] {
  --honorees-category-color: #111;
}

#top_special {
  scroll-margin: var(--header-height);
  margin: 5.4rem 0 0;
  padding: 4rem 0 0;
}

.top_honorees_subtitle {
  margin: 1.8rem 0 0;
  text-align: center;
  font-size: 3rem;
  letter-spacing: 0.04em;
}
.top_honorees_list + .top_honorees_subtitle {
  margin: 7.4rem 0 0;
}

#top_special .top_honorees_list {
  position: relative;
  grid-template-columns: repeat(3, 32.5%);
  gap: 4.2rem 1.25%;
  margin: 2.3rem 0 0;
}
#top_special .top_honorees_list::after {
  z-index: -1;
  position: absolute;
  bottom: -1.5rem;
  left: calc(50% - 50vw);
  content: "";
  width: 100vw;
  height: 58.18%;
  background: #fff;
  speak: none;
}
#top_special .top_honorees_list:not(:has(.top_honorees_list_item:nth-child(3))) {
  display: flex;
  justify-content: center;
}
#top_special .top_honorees_list:has(+ .top_special_link)::after {
  bottom: -13.7rem;
  height: calc(58.18% + 12.2rem);
}
#top_special .top_honorees_list_item {
  padding: 0 0 1rem;
  background: #929191;
}
#top_special .top_honorees_list:not(:has(.top_honorees_list_item:nth-child(3))) .top_honorees_list_item {
  max-width: 32.5%;
}
#top_special .top_honorees_list_item:first-child {
  grid-column: initial;
  display: block;
  margin: 0;
}
#top_special .top_honorees_list_button {
  display: grid;
  width: 100%;
}
#top_special .top_honorees_list_button:nth-child(2) {
  display: none;
}
#top_special .top_honorees_list_text_button {
  grid-column-start: 2;
  grid-row-start: 2;
  cursor: pointer;
}
#top_special .top_honorees_list_name_en {
  translate: 0 1.7rem;
  margin: 0;
  padding: 0 2rem;
  text-shadow: 0 0 0.4rem rgb(146, 145, 145), 0 0 0.4rem rgb(146, 145, 145);
  color: #111;
  font-size: 5rem;
}
#top_special .top_honorees_list_name_ja {
  margin: 2.7rem 0 0;
  padding: 0 2rem;
}
#top_special .top_honorees_list_position {
  margin: 0.5rem 0 0;
  padding: 0 2rem;
  font-size: 1.4rem;
  line-height: 1.7142857143;
}
#top_special .top_honorees_list_icons {
  grid-column-start: initial;
  grid-row-start: initial;
  gap: 1.4rem;
  margin: 1.7rem 2rem 0;
}
#top_special .top_honorees_list_ico {
  width: 4.2rem;
  height: 4.2rem;
}

.top_special_link {
  z-index: 1;
  position: relative;
  display: block;
  max-width: 40rem;
  margin: 4.4rem auto 10rem;
  border: solid 2px #111;
  border-radius: 0.6rem;
}

.top_special_link_inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem 0;
  color: #fff;
  font-size: 1.8rem;
  line-height: 0.85;
}

.top_special_link_inner_mufg {
  font-size: 3rem;
  letter-spacing: normal;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.top_special_link_arrow {
  fill: #fff;
}

/******************************
FTS
******************************/
[data-color=honorees-fts] {
  --honorees-category-color: #7224D8;
}

#top_fts {
  position: relative;
  margin: 14.5rem 0 0;
  padding: 10.5rem 0 8.2rem;
  text-align: center;
}
#top_fts::after {
  z-index: -1;
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  content: "";
  width: 100vw;
  height: 100%;
  background: var(--gradient-30under30);
  opacity: 0.5;
  speak: none;
}

.top_fts_title {
  z-index: 2;
  position: relative;
  margin: 0 calc(-1 * var(--overall-padding));
  font-size: 11rem;
  line-height: 0.85;
  white-space: nowrap;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.top_fts_inner {
  z-index: 1;
  position: relative;
  margin: -5rem 0 0;
  padding: 9rem 3rem 5.1rem;
  background: #111;
  overflow: hidden;
}

.top_fts_subtitle {
  margin: -2.2rem 0 0;
  font-size: 3rem;
}
.top_fts_subtitle::after {
  content: " ";
  margin-left: -0.4em;
  speak: none;
}

.top_fts_suported {
  position: relative;
  margin: -1.5rem 0 0;
  font-size: 2.4rem;
}
.top_fts_suported::before {
  position: absolute;
  bottom: -3rem;
  left: calc(50% - 15rem);
  content: "";
  width: 30rem;
  height: 3px;
  background: var(--gradient-30under30);
  speak: none;
}
.top_fts_suported::after {
  content: " ";
  margin-left: -0.4em;
  speak: none;
}

.top_fts_lead {
  margin: 5.5rem 0 0;
  font-size: 1.6rem;
  line-height: 2;
}

#top_fts .top_honorees_list {
  grid-template-columns: repeat(3, 26.33%);
  gap: 0 10.5%;
  max-width: 91.5rem;
  margin: 4.2rem auto 0;
  text-align: left;
}
#top_fts .top_honorees_list_item:first-child {
  grid-column: initial;
  display: block;
  margin: 0;
}
#top_fts .top_honorees_list_button {
  display: grid;
  width: 100%;
}
#top_fts .top_honorees_list_button:nth-child(2) {
  display: none;
}
#top_fts .top_honorees_list_text_button {
  grid-column-start: 2;
  grid-row-start: 2;
  cursor: pointer;
}
#top_fts .top_honorees_list_name_en {
  translate: 0 1.7rem;
  margin: 0;
  font-size: 4rem;
}
#top_fts .top_honorees_list_name_ja {
  margin: 2.7rem 0 0;
}
#top_fts .top_honorees_list_position {
  margin: 0.5rem 0 0;
  font-size: 1.4rem;
  line-height: 1.7142857143;
}
#top_fts .top_honorees_list_icons {
  grid-column-start: initial;
  grid-row-start: initial;
  gap: 1.4rem;
  margin: 1.7rem 0 0;
}
#top_fts .top_honorees_list_ico {
  width: 4.2rem;
  height: 4.2rem;
}

.top_fts_link {
  display: block;
  max-width: 32rem;
  margin: 5rem auto 0;
  border: solid 1px #fff;
  border-radius: 0.6rem;
  background-image: linear-gradient(to right, transparent 0, transparent 50%, #fff 50%, #fff 100%);
  font-size: 3rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  letter-spacing: normal;
}

.top_fts_link_inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.1rem 0;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: background-position 0.4s;
}

.top_fts_link_arrow {
  width: 2.2rem;
  height: 0.7rem;
  translate: 1rem 0;
}

.top_fts_link_arrow_use {
  fill: #fff;
}

.top_fts_bg {
  z-index: -1;
  position: absolute;
  bottom: 0;
  left: calc(50% - 51.6rem);
  width: 103.2rem;
  height: 68rem;
}

.top_fts_bg_use {
  fill: #2F2F2F;
}

/******************************
30 UNDER 30 CONTENTS
******************************/
#top_contents {
  scroll-margin: var(--header-height);
  margin: 13.9rem 0 0;
}

#podcasts,
#tiktok,
#youtube {
  scroll-margin: calc(var(--header-height) + 4rem);
}

.top_contents_title {
  text-align: center;
  font-size: 10rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.top_contents_item {
  position: relative;
  display: flex;
  gap: 5rem;
  align-items: flex-start;
  margin: 6.6rem 0 0;
  padding: 0 0 6.5rem;
}
.top_contents_item::after {
  z-index: -1;
  position: absolute;
  bottom: 0;
  left: calc(50% - 50vw);
  content: "";
  width: 100vw;
  height: 14rem;
  background: #7224D8;
  speak: none;
}
.top_contents_item + .top_contents_item {
  margin-top: 11rem;
}

#tiktok.top_contents_item::after {
  background: #10DBD5;
}

#youtube.top_contents_item {
  padding-bottom: 2.8rem;
}
#youtube.top_contents_item::after {
  background: #929191;
}

.top_contents_item_text {
  width: 32.75%;
}
#podcasts .top_contents_item_text {
  width: 39.58%;
}

.top_contents_item_title {
  display: flex;
  gap: 2.4rem;
  align-items: center;
  font-size: 7rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.top_contents_item_title_ico_pic {
  display: block;
  width: 7.4rem;
  aspect-ratio: 1;
}

.top_contents_item_title_ico_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.top_contents_item_title_ico {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7.4rem;
  aspect-ratio: 1;
  background: #fff;
  border-radius: 50%;
}

.top_contents_item_title_ico_svg_tiktok {
  width: 3.7rem;
  height: 4.3rem;
}

.top_contents_item_title_ico_use_tiktok_cyan {
  fill: #25f4ee;
}

.top_contents_item_title_ico_use_tiktok_red {
  fill: #fe2c55;
}

.top_contents_item_title_ico_use_tiktok_black {
  fill: 0;
}

.top_contents_item_title_ico_svg_youtube {
  width: 4.5rem;
  height: 3.2rem;
}

.top_contents_item_body {
  margin: 3.5rem 0 0;
  font-size: 1.6rem;
  line-height: 1.875;
  letter-spacing: 0.04em;
}

.top_contents_item_link {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  width: 30rem;
  margin: 1.2rem 0 0;
  padding: 0.4rem 0 0.4rem 1.5rem;
  border-bottom: solid 2px #fff;
  background-image: linear-gradient(to right, transparent 0, transparent 50%, #fff 50%, #fff 100%);
  font-size: 1.6rem;
  transition: background-position 0.4s, border-radius 0.4s;
}

.top_contents_item_link_spotify_logo {
  width: 2rem;
  height: 2rem;
}

.top_contents_item_link_spotify_logo_use {
  fill: #1ED760;
}

.top_contents_item_link_spotify_text {
  margin: 0 -0.7rem 0 0;
  color: #1ED760;
  font-size: 2.2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  letter-spacing: normal;
}

.top_contents_item_link_arrow {
  translate: 0.6rem -0.4rem;
  width: 2.2rem;
  height: 0.7rem;
}

.top_contents_item_link_arrow_use {
  fill: #fff;
}

.top_contents_item_embed {
  position: relative;
  flex: 1;
}
#podcasts .top_contents_item_embed {
  text-align: center;
}
#tiktok .top_contents_item_embed {
  margin-top: -1.8rem;
}

.tiktok-embed {
  border-radius: 1rem;
}

#top_contents_youtube_slider {
  width: 100%;
  max-width: 75.6rem;
  padding: 0 0 6rem;
}

.top_contents_youtube_item {
  width: 100% !important;
}

.top_contents_youtube_wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 560/315;
}

.top_contents_youtube_thumbnail {
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 10;
  clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);
  transition: clip-path 0.4s;
}
.top_contents_youtube_thumbnail.is-playing {
  clip-path: polygon(100% 0, 100% 0%, 100% 100%, 100% 100%);
  pointer-events: none;
}

.youtube_thumbnail_pic {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.youtube_thumbnail_pic::after {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  speak: none;
}

.youtube_thumbnail_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.youtube_play_triangle {
  z-index: 2;
  position: absolute;
  top: 50%;
  left: calc(50% + 0.6rem);
  translate: -50% -50%;
  cursor: pointer;
  display: block;
  width: 4.2rem;
  height: 4.4rem;
}

.youtube_play_triangle_use {
  fill: #fff;
}

.youtube_play_text {
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  cursor: pointer;
  display: block;
  width: 16.5rem;
  height: 16.5rem;
  transition: scale 0.4s;
  animation: youtube_play_text_animation 70s infinite linear 1s both;
}

@keyframes youtube_play_text_animation {
  from {
    rotate: 0deg;
  }
  to {
    rotate: 360deg;
  }
}
.youtube_play_text_use {
  fill: #fff;
}
.top_contents_youtube_player {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

#top_contents_youtube_slider .swiper-pagination {
  top: auto;
  bottom: 2.1rem;
  display: flex;
  width: calc(100% - 13.4rem);
  height: 2px;
  background: #fff;
}
#top_contents_youtube_slider .swiper-pagination-bullet {
  margin: 0;
  opacity: 1;
  width: 100%;
  height: 2px;
  background: none;
  border-radius: 0;
}
#top_contents_youtube_slider .swiper-pagination-bullet-active {
  background: #D0FD4A;
}

.top_contents_youtube-prev,
.top_contents_youtube-next {
  z-index: 10;
  position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  aspect-ratio: 1;
  inset: auto;
  bottom: 0;
  right: 0;
}
.top_contents_youtube-prev::after,
.top_contents_youtube-next::after {
  display: none;
}

.top_contents_youtube-prev {
  right: 4.9rem;
}

.top_contents_youtube-next {
  transform: scale(-1, 1);
}

.youtube_nav_arrow {
  width: 100%;
  height: 100%;
}

.youtube_nav_arrow_bg {
  fill: rgb(208, 253, 74);
  transition: fill 0.4s;
}

.youtube_nav_arrow_arrow {
  fill: #000;
  transition: fill 0.4s;
}

#top_contents_youtube_slider .swiper-button-disabled {
  opacity: 1;
}
#top_contents_youtube_slider .swiper-button-disabled .youtube_nav_arrow_bg {
  fill: rgba(208, 253, 74, 0);
}
#top_contents_youtube_slider .swiper-button-disabled .youtube_nav_arrow_arrow {
  fill: #fff;
}

/******************************
ADVISORY BOARD （共通部分は _sitecommon.scss）
******************************/
#top_advisoryboard {
  margin-top: 15rem;
}
#top_advisoryboard .adjust_br1 {
  display: none;
}
#top_advisoryboard .adjust_br2 {
  display: none;
}

/******************************
ABOUT 30 UNDER 30 JAPAN
******************************/
#about30u30 {
  padding: 14rem 0 11.9rem;
}

.about30u30_title {
  text-align: center;
  font-size: 10rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.about30u30_lead {
  margin: 2rem 0 0;
  padding: 0 3rem;
  text-align: center;
  font-size: 2rem;
  line-height: 1.8;
}

.about30u30_list {
  margin: 4.2rem 0 0;
}

.about30u30_list_item {
  display: flex;
  align-items: center;
  padding: 4.3rem 0 4.8rem;
  border: solid 1px #D9D9D9;
  border-width: 0 0 1px;
}
.about30u30_list_item:first-child {
  border-width: 1px 0;
}

.about30u30_list_item_title {
  position: relative;
  padding: 0 9.5rem 0 3.3rem;
  font-size: 3rem;
}
.about30u30_list_item_title::after {
  position: absolute;
  top: calc(50% - 3px);
  right: 4.3rem;
  content: "";
  width: 3.4rem;
  height: 6px;
  background: #D0FD4A;
  speak: none;
}

.about30u30_list_item_title_en {
  z-index: -1;
  position: absolute;
  top: calc(50% - 5.7rem);
  left: 9.5rem;
  white-space: nowrap;
  color: #666;
  font-size: 13rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.about30u30_list_item_body {
  flex: 1;
}

.about30u30_criteria_list {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  margin: 0.6rem 0 0;
}

.about30u30_criteria_list_item {
  padding: 0 0 0 4.3rem;
  background: url(./img/common/criteria_list_style.svg) 0 0.6rem/2.5rem 2.4rem no-repeat;
}

.about30u30_criteria_list_item_ico {
  display: inline-block;
  margin: 0 1.3rem 0 0;
  translate: 0rem 0.5rem;
}

.about30u30_criteria_list_item_ico_svg {
  width: 2.5rem;
  height: 2.4rem;
}

.about30u30_criteria_list_item_ico_use {
  fill: #fff;
}

.about30u30_criteria_comment {
  margin: 2.5rem 0 0;
}

/******************************
ARCHIVE
******************************/
.archive_past {
  position: relative;
  padding: 3.7rem 0 3.1rem;
  color: #111;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}
.archive_past::after {
  z-index: -5;
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  content: "";
  width: 100vw;
  height: 100%;
  background: #fff;
  speak: none;
}

.archive_past_list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2.2rem 12.833%;
  font-size: 10rem;
  line-height: 0.85;
}

.archive_past_list_item {
  padding: 0 0.5rem;
  text-align: center;
  background: linear-gradient(to right, #D0FD4A 0%, #FFD45E 16.665%, #FF7F9D 33.33%, #6657F6 calc(50% - 0.2rem), transparent calc(50% - 0.2rem), transparent 100%);
  background-size: 200% 100%;
  background-position: 100% 0;
  transition: background-position 0.4s;
}

.archive_past_list_link {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.archive_past_bg {
  z-index: -1;
  position: absolute;
  top: 50%;
  left: calc(50% - 50vw);
  translate: 0 -50%;
  display: flex;
  color: #EBEBEB;
  font-size: 32rem;
  line-height: 0.85;
}

.archive_bg_item {
  flex-shrink: 0;
  animation: archive_bg_item_animation 80s infinite linear 1s both;
}

@keyframes archive_bg_item_animation {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
.archive_other_list {
  display: flex;
  align-items: center;
  gap: 0 2.51%;
  margin: 4.7rem 0 0;
}

.archive_other_list_item {
  width: 31.66%;
  border: solid 2px #fff;
  border-radius: 0.6rem;
  color: #fff;
  font-size: 4rem;
  line-height: 1;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  letter-spacing: normal;
}

.archive_other_list_link {
  display: flex;
  align-items: center;
  gap: 0 15.2%;
  padding: 3rem 6% 2.6rem 12%;
}
.archive_other_list_link_text {
  white-space: nowrap;
}

.archive_other_list_accent {
  color: #E7161F;
}

.archive_other_list_link_arrow {
  translate: 0 -1.3rem;
}

.archive_other_list_link_arrow_use {
  fill: #fff;
}

/******************************
最新情報を受け取る
******************************/
.latestinfo {
  position: relative;
  margin: 13rem 0 0;
  padding: 2.5rem 0 10rem;
  text-align: center;
}

.latestinfo_title {
  margin: 2rem 0 0;
  font-size: 3rem;
}

.latestinfo_body {
  margin: 0.9rem 0 0;
  font-size: 1.6rem;
}

.latestinfo_link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 35rem;
  margin: 3.5rem auto 0;
  padding: 0.8rem 0 0.8rem 1rem;
  border: solid 1px #fff;
  border-radius: 0.6rem;
  transition: background-position 0.4s;
  color: #fff;
  font-size: 1.6rem;
  letter-spacing: normal;
}

.latestinfo_link_free {
  display: inline-block;
  padding: 0.4rem 0.6rem;
  background: #E7161F;
  color: #fff;
  font-size: 1.2rem;
  line-height: 1;
}

.latestinfo_link_arrow {
  translate: 0 -0.4rem;
}

.latestinfo_link_arrow_use {
  fill: #fff;
}

.latestinfo_subscription_bg_pic {
  z-index: -1;
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  width: 100vw;
  height: 100%;
  opacity: 0.62;
}

.latestinfo_subscription_bg_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

/******************************
Forbes JAPAN定期購読
******************************/
.latestinfo_subscription {
  position: relative;
  margin: 8rem 0 0;
  padding: 4rem 46.7rem 7.5rem 8.7rem;
  text-align: left;
  background: #000;
}

.latestinfo_subscription_title {
  font-size: 3rem;
  letter-spacing: 0.04em;
}

.latestinfo_subscription_body {
  margin: 1rem 0 0;
  font-size: 1.6rem;
}

.latestinfo_subscription_link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 35rem;
  margin: 4.1rem 0 0;
  padding: 1rem 0;
  border: solid 1px #fff;
  border-radius: 0.6rem;
  color: #fff;
  font-size: 1.6rem;
  letter-spacing: normal;
}

.latestinfo_subscription_link_accent {
  display: inline-block;
  padding: 0.4rem 0.6rem;
  background: #E7161F;
  color: #fff;
  font-size: 1.2rem;
  line-height: 1;
}

.latestinfo_subscription_link_arrow {
  translate: 0 -0.4rem;
}

.latestinfo_subscription_link_arrow_use {
  fill: #fff;
}

.latestinfo_subscription_pic {
  position: absolute;
  top: -5.4rem;
  right: 5rem;
  display: block;
  width: 41.6rem;
  aspect-ratio: 416/370;
}

.latestinfo_subscription_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

/******************************
SPONSOR
******************************/
#sponsor {
  scroll-margin: var(--header-height);
  position: relative;
  padding: 10.5rem 0 9.6rem;
}
#sponsor::after {
  z-index: -1;
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  content: "";
  width: 100vw;
  height: 100%;
  background: #fff;
  speak: none;
}

.sponsor_title {
  text-align: center;
  color: #111;
  font-size: 10rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.sponsor_list {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 7.6rem 7rem;
  margin: 9.7rem 0 0;
}

.sponsor_list_item:first-child {
  width: 100%;
}
.sponsor_list_item:nth-child(2) {
  margin: 0 0 0 -2rem;
}
.sponsor_list_item:nth-child(3) {
  margin: 0 0 0 -2rem;
}
.sponsor_list_item:nth-child(4) {
  margin: 0 0 0 0.5rem;
}
.sponsor_list_item:nth-child(5) {
  margin: -0.8rem 1.8rem 0;
}
.sponsor_list_item:nth-child(6) {
  margin: 1.2rem 0 0;
}
.sponsor_list_item:nth-child(7) {
  margin: 1.2rem 0 0;
}

.sponsor_list_item_inner {
  width: calc(var(--sponsor_logo_width) * 1rem);
}

.sponsor_list_item_inner_audi {
  --sponsor_logo_width: 30.6;
  aspect-ratio: 306/106;
  margin: 0 auto;
}

.sponsor_list_item_inner_mufg {
  --sponsor_logo_width: 27.5;
  aspect-ratio: 275/65;
}

.sponsor_list_item_inner_tokyu-land {
  --sponsor_logo_width: 32.3;
  aspect-ratio: 323/56;
}

.sponsor_list_item_inner_fts {
  --sponsor_logo_width: 22;
  aspect-ratio: 220/80;
}

.sponsor_list_item_inner_norqain {
  --sponsor_logo_width: 25.1;
  aspect-ratio: 251/92;
}

.sponsor_list_item_inner_samsung {
  --sponsor_logo_width: 23.4;
  aspect-ratio: 234/35;
}

.sponsor_list_item_inner_frenchbloom {
  --sponsor_logo_width: 37.7;
  aspect-ratio: 377/23;
}

.sponsor_list_svg {
  width: 100%;
  height: 100%;
}

/******************************
メイン （共通部分は _sitecommon.scss）
******************************/

.advisoryboard_lead_pic {
  width: 40.3rem;
}

.advisoryboard_lead_content {
  min-width: 55rem;
  padding: 10.3rem 3.4rem 6rem;
}

.advisoryboard_lead_hash {
  width: -moz-fit-content;
  width: fit-content;
  margin: 0.8rem auto 0;
  text-align: center;
  background: var(--gradient-30under30);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 4rem;
  line-height: 1;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.advisoryboard_lead_body {
  margin: 5.6rem 0 0;
  font-size: 2rem;
  line-height: 1.8;
}

/******************************
Article スライダー
******************************/
#advisoryboard_article {
  position: relative;
  padding: 13rem 0 0;
}

#advisoryboard_article_slider {
  padding: 0 0 9.8rem;
}

.advisoryboard_article_item {
  display: flex;
  align-items: flex-start;
  gap: 0 4.41%;
}

.advisoryboard_article_image {
  position: relative;
  width: 54%;
  aspect-ratio: 648/435;
  padding: 0.8rem;
}
.advisoryboard_article_image::before, .advisoryboard_article_image::after {
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 29%;
  aspect-ratio: 1;
  background: var(--gradient-30under30);
  speak: none;
}
.advisoryboard_article_image::after {
  inset: auto;
  bottom: 0;
  right: 0;
  transform: scale(-1, 1);
}

.advisoryboard_article_pic {
  display: block;
  overflow: hidden;
}

.advisoryboard_article_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  transition: scale 0.4s;
}

.advisoryboard_article_text {
  flex: 1;
  align-self: flex-end;
  padding: 0 0 1.7rem;
}

.advisoryboard_article_title {
  z-index: -1;
  position: relative;
  font-size: 2.8rem;
  line-height: 1.2857142857;
  letter-spacing: 0.04em;
}
.advisoryboard_article_title::after {
  position: absolute;
  bottom: -4.5rem;
  right: 0;
  content: "";
  width: calc(100% + 6.1rem);
  height: 1px;
  background: #D9D9D9;
  speak: none;
}

.advisoryboard_article_name {
  position: relative;
  margin: 7rem 0 0;
}

.advisoryboard_article_name_ja {
  font-size: 2.6rem;
  line-height: 1.3846153846;
  letter-spacing: 0.04em;
}

.advisoryboard_article_name_en {
  z-index: -1;
  position: absolute;
  top: -1rem;
  right: 0;
  width: -moz-fit-content;
  width: fit-content;
  color: #2F2F2F;
  font-size: 10rem;
  line-height: 0.76;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
}

.advisoryboard_article_position {
  margin: 0.5rem 0 0;
  font-size: 1.4rem;
  line-height: 1.7142857143;
}

.advisoryboard_article_more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.8rem;
  max-width: 32rem;
  margin: 4.1rem 0 0;
  padding: 0.9rem 2rem 0.9rem 3rem;
  color: #fff;
  border: solid 1px #fff;
  border-radius: 0.6rem;
  font-size: 3rem;
  line-height: 1;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  letter-spacing: normal;
}

.advisoryboard_article_more_use {
  fill: #fff;
}

#advisoryboard_article_slider .swiper-pagination {
  top: auto;
  bottom: 2.5rem;
  display: flex;
  width: calc(100% - 28.8rem);
  height: 2px;
  background: #fff;
}
#advisoryboard_article_slider .swiper-pagination-bullet {
  margin: 0;
  opacity: 1;
  width: 100%;
  height: 2px;
  background: none;
  border-radius: 0;
}
#advisoryboard_article_slider .swiper-pagination-bullet-active {
  background: #D0FD4A;
}
#advisoryboard_article_slider .swiper-counter {
  position: absolute;
  bottom: 1.3rem;
  right: 20.8rem;
  font-size: 3.5rem;
  line-height: 0.85;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  font-weight: 500;
}

.advisoryboard_article-prev,
.advisoryboard_article-next {
  z-index: 10;
  position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6.6rem;
  aspect-ratio: 1;
  inset: auto;
  bottom: 0;
  right: 0;
}
.advisoryboard_article-prev::after,
.advisoryboard_article-next::after {
  display: none;
}

.advisoryboard_article-prev {
  right: 8.3rem;
}

.advisoryboard_article-next {
  transform: scale(-1, 1);
}

.advisoryboard_article_nav_arrow {
  width: 100%;
  height: 100%;
}

.advisoryboard_article_nav_arrow_bg {
  fill: rgb(208, 253, 74);
  transition: fill 0.4s;
}

.advisoryboard_article_nav_arrow_arrow {
  fill: #000;
  transition: fill 0.4s;
}

#advisoryboard_article_slider .swiper-button-disabled {
  opacity: 1;
  cursor: default;
}
#advisoryboard_article_slider .swiper-button-disabled .advisoryboard_article_nav_arrow_bg {
  fill: rgba(208, 253, 74, 0);
}
#advisoryboard_article_slider .swiper-button-disabled .advisoryboard_article_nav_arrow_arrow {
  fill: #fff;
}

.advisoryboard_article_scroll_text {
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  display: flex;
}

.advisoryboard_article_scroll_text_item {
  flex-shrink: 0;
  -webkit-text-stroke: 1px #666;
  text-stroke: 1px #666;
  paint-order: stroke;
  color: transparent;
  font-size: 25rem;
  line-height: 0.72;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  animation: advisoryboard_article_scroll_text_animation 100s infinite linear 0s both;
}

@keyframes advisoryboard_article_scroll_text_animation {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
/******************************
アドバイザーリスト
******************************/
#advisoryboard_list {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(18.5rem, 1fr));
  align-items: flex-start;
  gap: 4.3rem 1.875%;
  margin: 11rem 0 0;
  padding: 8rem 0;
}
#advisoryboard_list::after {
  z-index: -1;
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  content: "";
  width: 100vw;
  height: 100%;
  background: #2F2F2F;
  speak: none;
}

.advisoryboard_list_item {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.2rem 0.8rem;
}

.advisoryboard_list_pic {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1;
  cursor: pointer;
}
.advisoryboard_list_pic::after {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  content: "PROFILE";
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #D0FD4A 0%, #FFD45E 33.33%, #FF7F9D 66.66%, #6657F6 100%);
  opacity: 0.7;
  color: #000;
  font-size: 4rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-family: "interstate-compressed", sans-serif;
  font-style: normal;
  clip-path: polygon(0 0, 0 0, 0 100%, 0% 100%);
  transition: clip-path 0.4s;
  speak: none;
}

.advisoryboard_list_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.advisoryboard_list_text {
  flex: 1;
}

.advisoryboard_list_name {
  margin: 0rem 0 0;
  font-size: 1.8rem;
  line-height: 1.1111111111;
}

.advisoryboard_list_position {
  margin: 0.8rem 0 0;
  font-size: 1.4rem;
  line-height: 1.4285714286;
  font-weight: 400;
}

.advisoryboard_list_ico_button,
.top_honorees_list_link {
  align-self: flex-start;
  display: block;
  cursor: pointer;
}

.advisoryboard_list_ico_svg {
  width: 3.4rem;
  height: 3.4rem;
  transition: scale 0.4s;
}

.advisoryboard_list_ico_use_bg {
  fill: #fff;
  transition: fill 0.4s;
}

.advisoryboard_list_ico_use_profile {
  fill: #000;
  transition: fill 0.4s;
}

@media screen and (max-width: 1440px) and (min-width: 1081px){
  .top_main_title {
    font-size: 0.6944444444vw;
  }
  .top_main_title .top_main_title_inner {
    font-size: 14.5em;
  }
}

@media screen and (max-width: 1425px) and (min-width: 761px){
  #top_advisoryboard .adjust_br1 {
    display: block;
  }
}

@media screen and (max-width: 1200px) and (min-width: 761px){
  .top_honorees_anchor_list {
    font-size: 0.8333333333vw;
  }
  .top_honorees_anchor_item {
    font-size: 3.7em;
  }
  .top_honorees_anchor_item[data-color=honorees-art] {
    font-size: 5em;
  }
}

@media screen and (max-width: 1180px) and (min-width: 1081px){
  .archive_other_list {
    gap: 0 1.8%;
  }
  .archive_other_list_item {
    width: 32.13%;
  }
  .archive_other_list_link {
    justify-content: center;
    gap: 0 2rem;
    padding: 3rem 1.5rem 2.6rem;
  }
}

@media screen and (max-width: 1140px){
  .sponsor_list {
    gap: 7.6rem 6.2rem;
  }
  .sponsor_list_item:nth-child(5) {
    margin: -0.8rem 0 0;
  }
}

@media screen and (max-width: 1120px){
  .top_fts_title {
    font-size: 10.5rem;
  }
}

@media screen and (max-width: 1080px) and (min-width: 761px){
  .tb-only-show {
    display: block;
  }
  .tb-only-hide {
    display: none;
  }
  #sponsor {
    font-size: 0.9259259259vw;
  }
  .sponsor_list {
    gap: 7.6em 6.9em;
    margin: 9.7rem calc(-1 * var(--overall-padding)) 0;
  }
  .sponsor_list_item_inner {
    width: calc(var(--sponsor_logo_width) * 1em);
  }
}

@media screen and (max-width: 1080px){
  :root {
    --header-height: 7rem;
  }
  .tb-show {
    display: block;
  }
  .tb-hide {
    display: none;
  }
  #header {
    padding: 0 2.1rem;
  }
  #menu_trigger {
    position: fixed;
    z-index: 10;
    top: 1.5rem;
    right: 1.4rem;
    display: block;
    width: 4rem;
    height: 4rem;
  }
  #menu {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2;
    translate: -100% 0;
    flex-direction: column;
    align-items: center;
    gap: 4rem 0;
    justify-content: flex-start;
    width: 100vw;
    height: auto;
    padding: 10rem 2.8rem;
    background: #fff;
    transition: translate 0.4s;
    height: 100vh;
    overflow-y: scroll;
    overflow-scrolling: touch;
    overscroll-behavior-y: contain;
  }
  .is-menuOpen #menu {
    translate: 0 0;
  }
  #menu_list {
    flex-direction: column;
    gap: 4.6rem 0;
    font-size: 2.6rem;
  }
  .header_x_inner {
    gap: 2.9rem;
    padding: 0.5rem 1.4rem 0.5rem 1.8rem;
    font-size: 1.4rem;
  }
  .header_sns_list {
    display: flex;
    gap: 2.6rem;
  }
  .top_main_title {
    font-size: 10rem;
  }
  .top_honorees_list_wrap,
  .top_honorees_item:nth-child(2n) .top_honorees_list_wrap {
    padding: 3rem 4rem 4rem;
  }
  .top_honorees_list {
    grid-template-columns: repeat(3, 31.33%);
    gap: 4.2rem 3%;
  }
  .top_honorees_list_item:first-child {
    grid-template-rows: 0 repeat(2, auto) 0;
    gap: 0 5%;
    margin: 0;
  }
  .top_fts_title {
    margin: 0 -4rem;
    font-size: 10rem;
  }
  .top_fts_inner {
    padding: 6.3rem 3rem 5.1rem;
  }
  .top_fts_subtitle {
    margin: 0;
  }
  .top_fts_lead {
    margin: 6rem 0 0;
  }
  #top_fts .top_honorees_list {
    grid-template-columns: repeat(3, 31%);
    gap: 0 3.5%;
  }
  .top_contents_item {
    flex-direction: column;
    gap: 3.5rem;
  }
  .top_contents_item_text {
    width: 100%;
  }
  #podcasts .top_contents_item_text {
    width: 100%;
  }
  .top_contents_item_embed {
    width: 100%;
  }
  .archive_past_list {
    gap: 2.2rem 6.5%;
  }
  .archive_other_list {
    flex-direction: column;
    gap: 2rem 0;
  }
  .archive_other_list_item {
    width: 100%;
    max-width: 38rem;
  }
  .latestinfo {
    margin: 5rem 0 0;
  }
  .latestinfo_subscription {
    padding: 4rem 8.7rem;
    text-align: center;
  }
  .latestinfo_subscription_link {
    margin: 4.1rem auto 0;
  }
  .latestinfo_subscription_pic {
    position: relative;
    inset: auto;
    margin: 4rem auto 0;
  }
}

@media screen and (max-width: 760px){
  :root {
    --overall-padding: 2rem;
  }
  html {
    font-size: 2.6666666667vw;
  }
  body {
    font-size: 1.6rem;
  }
  .sp-show {
    display: block;
  }
  .sp-hide {
    display: none;
  }
  .sp-show-inline {
    display: inline;
  }
  .sp-hide-inline {
    display: none;
  }
  .common_modal_inner {
    padding: 5.6rem 3rem 3.2rem;
  }
  .common_modal_close {
    top: -4.8rem;
    right: -3.9rem;
  }
  .common_modal_close::before, .common_modal_close::after {
    width: 2.8rem;
  }
  .common_modal_slider_name_ja {
    font-size: 2.6rem;
  }
  .common_modal_slider_position {
    font-size: 1.4rem;
  }
  .common_modal_slider_outline {
    font-size: 1.6rem;
  }
  .common_modal_slider_prev,
  .common_modal_slider_next {
    top: 3rem;
    right: 5.3rem;
  }
  .common_modal_slider_prev {
    right: 10rem;
  }
  .menu_item {
    background: none;
  }
  .menu_link {
    mix-blend-mode: normal;
    color: #000;
  }
  .advisoryboard_lead {
    flex-direction: column;
  }
  .advisoryboard_lead_pic {
    width: 100vw;
    height: 375/136;
  }
  .advisoryboard_lead_img {
    -o-object-position: top center;
    object-position: top center;
  }
  .advisoryboard_lead_bottom_img {
    -o-object-position: top center;
    object-position: top center;
  }
  .advisoryboard_lead_content {
    min-width: initial;
    padding: 5rem 4.5rem;
  }
  .advisoryboard_lead_title {
    font-size: 6rem;
  }
  .advisoryboard_lead_body {
    text-align: left;
    font-size: 1.8rem;
    letter-spacing: normal;
  }
  .advisoryboard_lead_link {
    margin: 4.6rem auto 0;
  }
  #top_main {
    height: calc(100svh - var(--header-height));
  }
  .top_main_text {
    padding: 0 0 2rem;
  }
  .top_main_logo30u30 {
    width: 11.8rem;
    height: 8rem;
  }
  .top_main_catch {
    font-size: 2rem;
  }
  .top_main_title {
    font-size: 6rem;
    line-height: 0.8333333333;
  }
  .top_main_images {
    height: calc(100svh - var(--header-height));
  }
  .top_main_pic {
    width: 27.5rem;
    height: 100%;
  }
  #top_honorees {
    padding: 4.8rem 0 0;
  }
  .top_honorees_title {
    font-size: 6rem;
  }
  .top_honorees_title_hash {
    margin: 1.2rem auto 0;
    font-size: 3.2rem;
  }
  .top_honorees_lead {
    text-align: left;
  }
  .top_honorees_anchor_list {
    position: relative;
    top: auto;
    flex-wrap: wrap;
    margin: 4.8rem 0 0;
  }
  .top_honorees_anchor_item {
    width: 50%;
    background-position: 100% 0;
    font-size: 2.2rem;
    line-height: 0.9090909091;
  }
  .top_honorees_anchor_item[data-color=honorees-art] {
    font-size: 2.2rem;
  }
  .top_honorees_anchor_link {
    padding: 1.4rem 0;
    background-position: 100% 0;
  }
  .top_honorees_item {
    scroll-margin: calc(var(--header-height));
    margin: 2.2rem 0 0;
  }
  .top_honorees_item_title {
    margin: 0 calc(-1 * var(--overall-padding));
    padding: 1.2rem 0;
    text-align: center;
    font-size: 3.6rem;
  }
  .top_honorees_list_wrap,
  .top_honorees_item:nth-child(2n) .top_honorees_list_wrap {
    margin: 1rem calc(-1 * var(--overall-padding)) 0;
    padding: 2.7rem 2rem;
  }
  .top_honorees_list {
    grid-template-columns: repeat(2, 44.77%);
    gap: 3.5rem 10.46%;
  }
  .top_honorees_list_name_en {
    translate: 0 1rem;
    font-size: 3rem;
  }
  .top_honorees_list_name_ja {
    margin: 1.6rem 0 0;
    font-size: 1.6rem;
  }
  .top_honorees_list_position {
    line-height: 1.2857142857;
  }
  .top_honorees_list_icons {
    gap: 1.5rem;
    margin: 1.4rem 0 0;
  }
  .top_honorees_list_ico {
    width: 3.8rem;
    height: 3.8rem;
  }
  .top_honorees_list_item:first-child {
    gap: 0 2.4rem;
  }
  .top_honorees_list_item:first-child .top_honorees_list_button {
    align-self: flex-start;
    width: 18rem;
  }
  .top_honorees_list_item:first-child .top_honorees_list_name_en {
    margin: 0;
    font-size: 3rem;
  }
  .top_honorees_list_item:first-child .top_honorees_list_name_ja {
    margin: 0.5rem 0 0;
  }
  .top_honorees_list_item:first-child .top_honorees_list_position {
    font-size: 1.4rem;
    line-height: 1.2857142857;
  }
  .top_honorees_list_item:first-child .top_honorees_list_icons {
    gap: 1.5rem;
    margin: 1.4rem 0 0;
  }
  .top_honorees_list_item:first-child .top_honorees_list_ico {
    width: 3.8rem;
    height: 3.8rem;
  }
  .top_honorees_scroll_text {
    left: -0.4rem;
  }
  .top_honorees_item:nth-child(2n) .top_honorees_scroll_text {
    left: calc(100% + 0.5rem);
  }
  .top_honorees_scroll_text_item {
    font-size: 18rem;
  }
  #top_special {
    margin: 0;
  }
  .top_honorees_subtitle {
    margin: 1.5rem 0 0;
    font-size: 2rem;
  }
  #top_special .top_honorees_list::after {
    display: none;
  }
  #top_special .top_honorees_list,
  #top_special .top_honorees_list:not(:has(.top_honorees_list_item:nth-child(3))) {
    display: flex;
    flex-direction: column;
    gap: 4rem;
    margin: 1.6rem 0 0;
  }
  #top_special .top_honorees_list_item {
    position: relative;
    padding: 0;
  }
  #top_special .top_honorees_list_item::after {
    z-index: -1;
    position: absolute;
    bottom: -1.7rem;
    left: calc(50% - 50vw);
    content: "";
    width: 100vw;
    height: calc(50% + 1.7rem);
    background: #fff;
    speak: none;
  }
  #top_special .top_honorees_list:not(:has(.top_honorees_list_item:nth-child(3))) .top_honorees_list_item {
    max-width: initial;
  }
  #top_special .top_honorees_list_item,
  #top_special .top_honorees_list_item:first-child {
    display: grid;
    grid-template-columns: 18rem 1fr;
    grid-template-rows: repeat(2, auto);
    gap: 0 1.9rem;
  }
  #top_special .top_honorees_list_button {
    grid-row: initial;
  }
  #top_special .top_honorees_list_button:first-child {
    grid-column: 1/2;
    grid-row: 1/3;
    display: block;
    height: 100%;
  }
  #top_special .top_honorees_list_button:nth-child(2) {
    display: block;
    padding: 0 2rem 0 0;
  }
  #top_special .top_honorees_list_pic {
    display: block;
    height: 100%;
  }
  #top_special .top_honorees_list_name_en {
    padding: 0;
    font-size: 2.6rem;
  }
  #top_special .top_honorees_list_name_ja {
    margin: 1.9rem 0 0;
    padding: 0;
  }
  #top_special .top_honorees_list_position {
    padding: 0;
    font-size: 1.2rem;
    line-height: 1.3333333333;
  }
  #top_special .top_honorees_list_icons {
    grid-column: 2/3;
    grid-row: 2/3;
    gap: 1.4rem;
    margin: 1.4rem 0rem 0;
    padding: 0 0 0.3rem;
  }
  #top_special .top_honorees_list_ico {
    width: 3.8rem;
    height: 3.8rem;
  }
  .top_special_link {
    max-width: 28rem;
    margin: 4.4rem auto 5rem;
    border-color: #fff;
  }
  .top_special_link_inner {
    font-size: 1.4rem;
  }
  .top_special_link_inner_mufg {
    font-size: 2.4rem;
  }
  #top_fts {
    margin: 8rem 0 0;
    padding: 3.5rem 0 2rem;
  }
  .top_fts_title {
    font-size: 6rem;
  }
  .top_fts_inner {
    margin: -3rem 0 0;
    padding: 3.7rem 2.5rem 2.7rem;
  }
  .top_fts_subtitle {
    margin: 0 -2.5rem;
    font-size: 2rem;
  }
  .top_fts_suported {
    margin: -1.1rem 0 0;
    font-size: 1.6rem;
  }
  .top_fts_suported::before {
    left: calc(50% - 10.25rem);
    bottom: -2.2rem;
    width: 20.5rem;
  }
  .top_fts_lead {
    margin: 4.5rem 0 0;
    text-align: left;
  }
  #top_fts .top_honorees_list {
    display: flex;
    flex-direction: column;
    gap: 4rem 0;
    margin: 4.2rem -2.5rem 0 0;
  }
  #top_fts .top_honorees_list_item,
  #top_fts .top_honorees_list_item:first-child {
    display: grid;
    grid-template-columns: 17rem 1fr;
    grid-template-rows: repeat(2, auto);
    gap: 0;
  }
  #top_fts .top_honorees_list_button {
    grid-row: initial;
  }
  #top_fts .top_honorees_list_button:first-child {
    align-self: flex-start;
    grid-column: 1/2;
    grid-row: 1/3;
    display: block;
  }
  #top_fts .top_honorees_list_button:nth-child(2) {
    display: grid;
    translate: -1rem 1rem;
    display: block;
    padding: 0 1rem 0 0;
    text-shadow: 0 0.4rem 1.8rem rgb(0, 0, 0);
  }
  #top_fts .top_honorees_list_pic {
    align-self: flex-start;
    display: block;
    height: 17rem;
  }
  #top_fts .top_honorees_list_name_en {
    translate: 0 0;
    font-size: 3rem;
  }
  #top_fts .top_honorees_list_name_ja {
    margin: 0.7rem 0 0;
  }
  #top_fts .top_honorees_list_position {
    margin: 1.1rem 0 0;
    font-size: 1.4rem;
    line-height: 1.2857142857;
  }
  #top_fts .top_honorees_list_icons {
    translate: -1rem 1rem;
    gap: 1rem;
    margin: 0.8rem 0 0;
  }
  #top_fts .top_honorees_list_ico {
    width: 3.8rem;
    height: 3.8rem;
  }
  .top_fts_link {
    max-width: 26rem;
    margin: 3.4rem auto 0;
    font-size: 2.4rem;
  }
  .top_fts_link_inner {
    padding: 0.9rem 0;
  }
  .top_fts_bg {
    top: 0;
    bottom: auto;
    left: calc(50% - 18.6rem);
    width: 37.2rem;
    height: 25.7rem;
  }
  #top_contents {
    margin: 5.5rem 0 0;
  }
  .top_contents_title {
    font-size: 6rem;
  }
  .top_contents_item {
    margin: 4.6rem 0 0;
    padding: 0 0 1rem;
  }
  .top_contents_item + .top_contents_item {
    margin-top: 6rem;
  }
  .top_contents_item_title {
    gap: 1.3rem;
    font-size: 3.8rem;
  }
  .top_contents_item_title_ico_pic {
    width: 4rem;
  }
  .top_contents_item_title_ico {
    width: 4rem;
  }
  .top_contents_item_title_ico_svg_tiktok {
    width: 2rem;
    height: 2.3rem;
  }
  .top_contents_item_title_ico_svg_youtube {
    width: 2.4rem;
    height: 1.7rem;
  }
  .top_contents_item_body {
    margin: 1.5rem 0 0;
  }
  .top_contents_item_link {
    justify-content: center;
    margin: 1.2rem auto 0;
  }
  .youtube_play_triangle {
    left: calc(50% + 0.3rem);
    width: 2.1rem;
    height: 2.2rem;
  }
  .youtube_play_text {
    width: 8.2rem;
    height: 8.2rem;
  }
  #top_advisoryboard {
    margin-top: 7rem;
  }
  #about30u30 {
    padding: 6rem 0;
  }
  .about30u30_title {
    font-size: 6rem;
    white-space: nowrap;
  }
  .about30u30_lead {
    margin: 2.5rem 0 0;
    padding: 0 1rem;
    text-align: left;
    font-size: 1.8rem;
  }
  .about30u30_list_item {
    flex-direction: column;
    gap: 2.5rem;
  }
  .about30u30_list_item_title {
    padding: 0;
    font-size: 2.4rem;
  }
  .about30u30_list_item_title::after {
    top: auto;
    bottom: -1rem;
    right: calc(50% - 1.7rem);
  }
  .about30u30_list_item_title_en {
    top: calc(50% + 0.2rem);
    left: 50%;
    translate: -50% -50%;
    color: #555;
    font-size: 9rem;
  }
  .about30u30_list_item_body {
    padding: 0 1rem;
  }
  .about30u30_criteria_list_item {
    padding: 0 0 0 3rem;
    background-position: 0 0.9rem;
    background-size: 1.7rem 1.6rem;
  }
  .archive_past_list {
    font-size: 6rem;
  }
  .archive_past_bg {
    overflow: hidden;
    font-size: 38rem;
    line-height: 0.69;
  }
  .archive_other_list {
    margin: 4.7rem 2rem 0;
  }
  .archive_other_list_item {
    max-width: initial;
    font-size: 3rem;
  }
  .latestinfo {
    padding: 2.5rem 0 5rem;
  }
  .latestinfo_subscription {
    margin: 5rem 0 0;
    padding: 2.5rem 2rem;
    text-align: left;
  }
  .latestinfo_subscription_title {
    text-align: center;
    font-size: 2.5rem;
  }
  .latestinfo_subscription_pic {
    max-width: 100%;
  }
  #sponsor {
    padding: 5rem 0 9rem;
  }
  .sponsor_title {
    font-size: 6rem;
  }
  .sponsor_list {
    gap: 5.5rem 7rem;
    margin: 6.5rem 0 0;
    padding: 0 4rem;
  }
  .sponsor_list_item_inner {
    width: calc(var(--sponsor_logo_width) * 0.75rem);
  }
  #advisoryboard_main .adjust_br1,
  #advisoryboard_main .adjust_br2 {
    display: none;
  }
  .advisoryboard_lead_hash {
    margin: 1.2rem auto 0;
    font-size: 3.2rem;
  }
  .advisoryboard_lead_body {
    margin: 1.6rem 0 0;
    text-align: left;
    font-size: 1.8rem;
  }
  #advisoryboard_article {
    padding: 6rem 0 0;
  }
  #advisoryboard_article_slider {
    padding: 0 0 6.8rem;
  }
  .advisoryboard_article_item {
    flex-direction: column;
    gap: 2rem 0;
  }
  .advisoryboard_article_image {
    width: 100%;
  }
  .advisoryboard_article_text {
    align-self: auto;
  }
  .advisoryboard_article_title {
    font-size: 2rem;
  }
  .advisoryboard_article_title::after {
    bottom: -2.2rem;
    width: 100%;
  }
  .advisoryboard_article_name {
    margin: 4rem 0 0;
  }
  .advisoryboard_article_name_ja {
    font-size: 1.8rem;
  }
  .advisoryboard_article_name_en {
    top: 0.5rem;
    font-size: 6rem;
  }
  #advisoryboard_article_slider .swiper-pagination {
    bottom: 1.8rem;
    width: calc(100% - 16.8rem);
  }
  #advisoryboard_article_slider .swiper-counter {
    bottom: 0.6rem;
    right: 10.1rem;
    font-size: 2.7rem;
  }
  .advisoryboard_article-prev,
  .advisoryboard_article-next {
    width: 3.8rem;
  }
  .advisoryboard_article-prev {
    right: 4.8rem;
  }
  #advisoryboard_list {
    grid-template-columns: repeat(2, 15.75rem);
    gap: 2.5rem 2rem;
    margin: 5rem 0 0;
    padding: 2.5rem 0;
  }
  .advisoryboard_list_name {
    font-size: 1.6rem;
  }
  .advisoryboard_list_position {
    margin: 0.4rem 0 0;
    font-size: 1.2rem;
  }
}

@media (hover: hover){
  .csshover:hover {
    opacity: 0.6;
  }
  .common_link_hover_slide_bg:hover {
    background-position: 100% 0;
  }
  .sns_list_link:hover .sns_list_svg,
  .sns_list_link:hover .sns_list_instagram_img {
    scale: 1.16;
  }
  .top_honorees_list_button:hover .top_honorees_list_pic::after, .top_honorees_list_button.is-hover .top_honorees_list_pic::after {
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);
  }
  .top_honorees_list_profile:hover .top_honorees_list_ico,
  .top_honorees_list_link:hover .top_honorees_list_ico {
    scale: 1.15;
  }
  .top_honorees_list_profile:hover .top_honorees_list_ico_bg,
  .top_honorees_list_link:hover .top_honorees_list_ico_bg {
    fill: var(--honorees-category-color);
  }
  .top_honorees_list_profile:hover .top_honorees_list_ico_object,
  .top_honorees_list_link:hover .top_honorees_list_ico_object {
    fill: #fff;
  }
  #feature .top_honorees_list_profile:hover .top_honorees_list_ico_bg,
  #feature .top_honorees_list_link:hover .top_honorees_list_ico_bg {
    fill: #000;
  }
  #feature .top_honorees_list_profile:hover .top_honorees_list_ico_object,
  #feature .top_honorees_list_link:hover .top_honorees_list_ico_object {
    fill: #fff;
  }
  .top_contents_item_link:hover {
    border-radius: 0.6rem;
  }
  .top_contents_youtube_thumbnail:hover .youtube_play_text {
    scale: 1.1;
  }
  .archive_past_list_item:hover {
    background-position: 0 0;
  }
  .advisoryboard_article_item:hover .advisoryboard_article_img {
    scale: 1.1;
    filter: grayscale(1);
  }
  .advisoryboard_article_item:hover .advisoryboard_article_more {
    background-position: 100% 0;
  }
  .advisoryboard_list_pic:hover::after, .advisoryboard_list_pic.is-hover::after {
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);
  }
  .advisoryboard_list_ico_button:hover .advisoryboard_list_ico_svg,
  .top_honorees_list_link:hover .advisoryboard_list_ico_svg {
    scale: 1.2;
  }
  .advisoryboard_list_ico_button:hover .advisoryboard_list_ico_use_bg,
  .top_honorees_list_link:hover .advisoryboard_list_ico_use_bg {
    fill: #000;
  }
  .advisoryboard_list_ico_button:hover .advisoryboard_list_ico_use_profile,
  .top_honorees_list_link:hover .advisoryboard_list_ico_use_profile {
    fill: #fff;
  }
}

@media (prefers-reduced-motion: reduce){
  .wf-active .top_main_images_item,
  .wf-inactive .top_main_images_item {
    animation: none;
  }
  .top_honorees_scroll_text_item {
    animation: none;
  }
  .youtube_play_text {
    animation: none;
  }
  .archive_bg_item {
    animation: none;
  }
  .advisoryboard_article_scroll_text_item {
    animation: none;
  }
}